import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import Link from 'components/shared/link';
import { BREAKPOINT_MD, BREAKPOINT_LG } from 'constants/breakpoints';
import useWindowWidth from 'hooks/use-window-width';
import CloseIcon from 'images/shared/header/close.inline.svg';
import Logo from 'images/shared/header/logo.inline.svg';
import MenuIcon from 'images/shared/header/menu.inline.svg';

import styles from './header.module.scss';

const cx = classNames.bind(styles);

const NAV_ITEMS = [
  {
    label: 'ABOUT',
    url: '#about',
  },
  {
    label: 'HOW IT WORKS',
    url: '#how-it-works',
  },
  {
    label: 'SUPPORTED STORES',
    url: '#stores',
  },
  {
    label: 'PRODUCTS',
    url: '#products',
  },
  {
    label: 'FAQ',
    url: '#faq',
  },
  {
    label: 'SUBSCRIBE',
    url: '#subscribe',
  },
];

const DesktopNav = () => (
  <ul className={cx('list')}>
    {NAV_ITEMS.map(({ label, url }) => {
      return (
        <li className={cx('item')} key={label}>
          <Link className={cx('link')} to={url}>
            {label}
          </Link>
        </li>
      );
    })}
  </ul>
);

const MobileNav = ({ isVisible, onClose }) => (
  <div className={cx('mobile-wrapper', isVisible && 'mobile-wrapper-visible')}>
    <div className={cx('close-button')} onClick={onClose}>
      <CloseIcon />
    </div>
    <div className={cx('list-mobile')}>
      {NAV_ITEMS.map(({ label, url }) => (
        <li className={cx('item')} key={label}>
          <Link className={cx('link')} to={url} onClick={onClose}>
            {label}
          </Link>
        </li>
      ))}
    </div>
  </div>
);

const Header = ({ className }) => {
  const windowWidth = useWindowWidth();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.querySelector('html').style.overflow = 'hidden';
    } else {
      document.querySelector('html').style.overflow = '';
    }
  }, [isMenuOpen]);

  return (
    <>
      <nav className={cx('wrapper', className)}>
        <div className={cx('container', 'row', 'inner')}>
          <a className={cx('logo')} href="/">
            <Logo />
          </a>
          {windowWidth > BREAKPOINT_LG && <DesktopNav />}
          {windowWidth <= BREAKPOINT_LG && (
            <div className={cx('menu-button')} onClick={() => setIsMenuOpen(true)}>
              <MenuIcon />
            </div>
          )}
        </div>
      </nav>
      <MobileNav isVisible={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
};

Header.propTypes = {
  className: PropTypes.string,
};

Header.defaultProps = {
  className: null,
};

export default Header;
